// Centralized asset URL builder that prefers the CDN base when available and
// gracefully falls back to the configured PUBLIC_URL or root-relative paths.
// Usage: assetUrl('assets/img/user.png') or assetUrl(`assets/img/exams/${logo}`)
// Special case: when using CDN we strip the legacy 'assets/img/' prefix so the
// CDN paths do not duplicate directory names.

const isAbsoluteAsset = (value) => {
	if (!value) return false;
	const str = String(value);
	return /^data:/i.test(str) || /^([a-z][a-z0-9+.-]*:)?\/\//i.test(str);
};

const trimmedEnv = (value) => (value ? String(value).replace(/\/+$/, '') : '');

export function assetUrl(relPath) {
	if (!relPath) return '';
	if (isAbsoluteAsset(relPath)) {
		return String(relPath);
	}
	const cdn = trimmedEnv(typeof process !== 'undefined' && process.env && process.env.REACT_APP_CDN_URL);
	const pub = trimmedEnv(typeof process !== 'undefined' && process.env && process.env.REACT_APP_PUBLIC_URL);
	let cleaned = String(relPath).replace(/^\/+/, '');
	if (cdn) {
		cleaned = cleaned.replace(/^assets\/img\/?/i, '');
		return `${cdn}/${cleaned}`;
	}
	const fallback = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
	const base = pub || fallback;
	return base ? `${base}/${cleaned}` : `/${cleaned}`;
}

export function localAssetUrl(relPath) {
	if (!relPath) return '';
	if (isAbsoluteAsset(relPath)) {
		return String(relPath);
	}
	const pub = trimmedEnv(typeof process !== 'undefined' && process.env && process.env.REACT_APP_PUBLIC_URL);
	const cleaned = String(relPath).replace(/^\/+/, '');
	if (pub) {
		return `${pub}/${cleaned}`;
	}
	return `/${cleaned}`;
}

export const examLogoUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/exams/${file}`);
};

/*export const subjectLogoUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/subjects/${file}`);
};
*/
const CDN_URL = (process.env.REACT_APP_CDN_URL || "https://d1y05uge6p72o2.cloudfront.net").replace(/\/+$/, '');

export const subjectLogoUrl = (logo) => {
  if (!logo) {
    return `${CDN_URL}/subjects/default-subject-icon.png`;
  }
  
  // If logo already has full URL, return as is
  if (logo.startsWith('http://') || logo.startsWith('https://')) {
    return logo;
  }
  
  // Otherwise, prepend CDN URL
  return `${CDN_URL}/subjects/${logo}`;
};

export const assessmentImageUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/assessments/${file}`);
};

export const questionImageUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/questions/${file}`);
};

export const testimonialImageUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/testimonial/${file}`);
};

export const newsImageUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	// Always use CDN for news images
	return `${CDN_URL}/news/${file}`;
};

export const imageNotificationUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return `${CDN_URL}/image-notifications/${file}`;
};

export const categoryImageUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/categories/${file}`);
};

export const bannerImageUrl = (file) => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return assetUrl(`assets/img/${file}`);
};

export const userAvatarUrl = (file = 'user.png') => {
	if (!file) return '';
	if (isAbsoluteAsset(file)) {
		return String(file);
	}
	return localAssetUrl(`assets/img/${file}`);
};

export const placeholderImageUrl = () => assetUrl('assets/img/No-Image-Placeholder.svg.png');

export const logoUrl = () => assetUrl('assets/img/logo.png');

export const footerLogoUrl = () => assetUrl('assets/img/foot-logo.png');
